import * as currentPage from "../actions//currentPage.action"
import * as sideBarExpand from "../actions//currentPage.action"

const initialState = {
  currentPage: "",
  data: [],
  isExpanded: true
}




export default function returnstate(state = initialState, action) {
  switch (action.type) {
    case currentPage.CURRENT_PAGE.SUCCESS:
      return {
        ...state,
        currentPage: action.payload.currentPage
      };

    case sideBarExpand.SIDEBAR_EXPAND.SUCCESS:
      return {
        ...state,
        isExpanded: action.payload.isExpanded
      };

    default: return state
  }
}